import React from "react";
import { Section, Field, TextField } from "./ReviewFields";

export default function SupplierSection({ extracted, upd, suppliers, applySupplier, hidePicker = false }) {
  const missingAddress = !extracted.supplier_address?.trim();

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-[#E8E4D9] p-5 sm:p-6">
      <Section title="DATI FORNITORE" testid="section-fornitore">
        {!hidePicker && (
          <div className="rounded-lg border border-blue-200 bg-blue-50/50 p-3 mb-4" data-testid="supplier-picker-block">
            <label className="block text-[10px] font-semibold text-blue-700 uppercase tracking-wider mb-1.5">
              Precompila da anagrafica fornitori
            </label>
            <select
              onChange={(e) => applySupplier(e.target.value)}
              defaultValue=""
              data-testid="supplier-picker"
              className="w-full h-10 px-3 rounded-md border border-blue-300 bg-white text-sm focus:border-[#0A0A0A] outline-none"
            >
              <option value="">-- Seleziona un fornitore --</option>
              {suppliers.map((s, i) => (
                <option key={s.id ?? `${s.supplier_name}-${s.supplier_vat_id ?? i}`} value={i}>
                  {s.supplier_name} {s.supplier_vat_id ? `(${s.supplier_vat_id})` : ""} {s.supplier_country ? `— ${s.supplier_country}` : ""}
                </option>
              ))}
            </select>
            <p className="text-xs text-blue-800 mt-1.5">
              Seleziona un fornitore per riempire automaticamente i campi sottostanti. Puoi comunque modificarli prima di salvare.
            </p>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Denominazione" required span={2}>
            <TextField value={extracted.supplier_name} onChange={upd("supplier_name")} testid="field-supplier-name" />
          </Field>
          <Field label="Paese (ISO 2)" required>
            <TextField value={extracted.supplier_country} onChange={upd("supplier_country")} mono maxLength={2} testid="field-supplier-country" />
          </Field>
          <Field label="P.IVA / Tax ID" hint="Se non indicato in fattura verrà usato il placeholder 99999999999.">
            <TextField value={extracted.supplier_vat_id || ""} onChange={upd("supplier_vat_id")} mono testid="field-supplier-vat" />
          </Field>
          <Field
            label="Indirizzo"
            span={2}
            icon={
              missingAddress ? (
                <span
                  className="ml-auto inline-flex items-center justify-center w-6 h-6 rounded bg-red-500 text-white text-xs font-bold"
                  data-testid="missing-address-icon"
                >
                  !
                </span>
              ) : null
            }
          >
            <TextField value={extracted.supplier_address} onChange={upd("supplier_address")} testid="field-supplier-address" />
          </Field>
          <Field label="CAP / ZIP" hint="Per SDI il CAP fornitore è sempre 00000 sulle autofatture estere">
            <TextField value="00000" onChange={() => {}} mono testid="field-supplier-zip" readOnly />
          </Field>
          <Field label="Comune / Città">
            <TextField value={extracted.supplier_city} onChange={upd("supplier_city")} testid="field-supplier-city" />
          </Field>
          <Field label="Nazione (ISO 2)">
            <TextField value={extracted.supplier_country} onChange={upd("supplier_country")} mono maxLength={2} testid="field-supplier-nazione" />
          </Field>
        </div>
      </Section>
    </div>
  );
}
